export default function ExecutionProvider(execution) {
  return function (context) {
    context.execution = execution;

    return context;
  };
}
//# sourceMappingURL=Execution.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/function-tree/es/providers/Execution.js
// module id = 522
// module chunks = 1